import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TransactionsType = () => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('transactiontype');
    const [data, setData] = useState(undefined);
    const [code, setCode] = useState('');
    const [transactionType, setTransactionType] = useState('');
    const [btnActive, setBtnActive] = useState(true);
    const [selectRowData, setSelectRowData] = useState('');
    const [emptyCode, setEmptyCode] = useState(false);
    const [emptyDesc, setEmptyDesc] = useState(false);
    const [emptyInput, setEmptyInput] = useState(false);

    function setSelectedRow(rowid) {
        const currunt_ID = rowid;
        console.log(currunt_ID);
        axios.get(`${baseUrl}${pageComponent}/show/${currunt_ID}`).then(res => {
            const selectRowData = res.data;
            console.log(selectRowData);
            setSelectRowData(selectRowData);
            setCode(selectRowData.transactiontypes.Code ? selectRowData.transactiontypes.Code : '');
            setTransactionType(selectRowData.transactiontypes.TransactionType ? selectRowData.transactiontypes.TransactionType : '');
            setBtnActive(false);
        })
    }

    const createNewRow = () => {
        setBtnActive(false);
        setSelectRowData('');
        setCode('');
        setTransactionType('');
    }

    const edditRow = (event) => {
        event.preventDefault();
        if (selectRowData !== '') {
            const inputData = { Code: code, TransactionType: transactionType };
            axios.post(`${baseUrl}${pageComponent}/${selectRowData.transactiontypes.id}/update`, inputData)
                .then(response => {
                    toast.success('Successfully Save Data ! ', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    setTimeout(window.location.reload.bind(window.location), 2000);
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            toast.error("Please Select data Row", {
                position: toast.POSITION.TOP_RIGHT
            })
        }
    }

    const handleSave = async (event) => {

        if (code.length == 0) {
            toast.error("Transaction Code can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCode(true);
            setEmptyInput(true);
        } else {
            setEmptyCode(false);
        }

        if (transactionType.length == 0) {
            toast.error("Transaction Class can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyDesc(true);
            setEmptyInput(true);

        } else {
            setEmptyDesc(false);
        }

        if (emptyInput !== true) {
            const inputData = { Code: code, TransactionType: transactionType };
            const duplicate = await data.some(el => el.Code == code);
            if (duplicate !== true) {

                axios.post(`${baseUrl}${pageComponent}/store`, inputData)
                    .then(response => {
                        toast.success('Successfully Save Data ! ', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setTimeout(window.location.reload.bind(window.location), 2000);

                    })
                    .catch(error => {
                        console.error(error);
                    });
            } else {

                toast.error("This currency code already included", {
                    position: toast.POSITION.TOP_RIGHT
                })


            }
        } else {

        }
    
    }

    useEffect(() => {
        fetch(`${baseUrl}${pageComponent}/index`)
            .then(response => response.json())
            .then(data => {
                setData(data.transactiontypes);
                console.log(data.country)
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const deleteRow = (event) => {
        event.preventDefault();
        axios.delete(`${baseUrl}${pageComponent}/${selectRowData.transactiontypes.id}/destroy`, selectRowData.transactiontypes.id)
        toast.warning('Successfully Deleted Data Row', {
            position: toast.POSITION.TOP_RIGHT
        });
        setTimeout(window.location.reload.bind(window.location), 2000);
    }

    const columns = ['Code', 'TransactionType',];

    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-3 bottom-border pb-3'>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Code</Form.Label>
                                    <Form.Control type="text" placeholder="001" name="code" value={code} readOnly={selectRowData !== '' ? true : false} className={emptyCode == true ? 'border-red2' : ''} onChange={e => setCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Transactions Type</Form.Label>
                                    <Form.Control type="text" placeholder="Invoice" name="transactionType" value={transactionType} className={emptyDesc == true ? 'border-red2' : ''} onChange={e => setTransactionType(e.target.value)}/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='text-center'>
                            <Col className='text-end'>
                            <Button className="ms-3" variant="primary" onClick={selectRowData !== '' ? edditRow : handleSave} disabled={btnActive}>
                                    Save
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={createNewRow}>
                                    New
                                </Button>

                                <Button className="ms-3" variant="primary" onClick={edditRow} disabled={btnActive}>
                                    Update
                                </Button>
                                <Button className="ms-3" variant="primary" onClick={deleteRow} disabled={btnActive}>
                                    Delete
                                </Button>

                                <Button className="ms-3" variant="primary" disabled={btnActive}>
                                    Print
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <TableView data={data} columns={columns} setSelectedRow={setSelectedRow}/>
                </Col>
            </Row>
        </Container>
    );
}

export default TransactionsType;